import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { SofiaAvatar } from "@/components/sofia-avatar"
import { useUserStore } from "@/lib/fetch-users"
import { UserRole } from "@/types/__generated__/union-types"

type AgentOption = {
  kind?: "User"
  label: string
  icon?: React.JSX.Element
  value: string
  role: UserRole | null
  specialties: string
  isDeleted: boolean
}

const useAgentOptions = (): AgentOption[] => {
  const { t } = useTranslation()
  const users = useUserStore((state) => state.users)

  return useMemo(() => {
    return users
      ? [...users.values()]
          .map((item) => {
            const { firstName, lastName, userName, role, roleData, isDeleted } = item
            const specialties = roleData?.specialties
              ? roleData.specialties
                  .map((specialty) => t(`scheduling.waitingRoom.specialty.${specialty.skill}`))
                  .join(", ")
              : ""

            return {
              label: `${firstName} ${lastName}`,
              icon: <SofiaAvatar firstName={firstName} lastName={lastName} role={role} size="md" />,
              value: userName,
              role,
              specialties,
              isDeleted,
            }
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      : []
  }, [users, t])
}
export { useAgentOptions, type AgentOption }
